import React from 'react'
// import { buildImageObj } from '../../lib/helpers'
// import { imageUrlFor } from '../../lib/image-url'

// import styles from './figure.module.css'

function FileDownload(props) {
  return (
    <div className="my-4">
      <a
        href={props.asset.url}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black button hover:bg-red text-white font-bold py-2 px-4 text-xs no-underline"
      >
        {props.label}
      </a>
    </div>
  )
}

export default FileDownload
